var _sodipodiNamedview, _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiagonal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    id: "svg7767",
    xmlSpace: "preserve",
    sodipodiDocname: "diagonal.svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs7771"
  }, /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "marker7",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    inkscapeStockid: "Wide, rounded arrow",
    markerWidth: 1,
    markerHeight: 1,
    viewBox: "0 0 1 1",
    inkscapeIsstock: "true",
    inkscapeCollect: "always",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "context-stroke",
      strokeWidth: 1,
      strokeLinecap: "round"
    },
    d: "M 3,-3 0,0 3,3",
    transform: "rotate(180,0.125,0)",
    sodipodiNodetypes: "ccc",
    id: "path7"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "ArrowWideRounded",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 1,
    markerHeight: 1,
    viewBox: "0 0 1 1",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "context-stroke",
      strokeWidth: 1,
      strokeLinecap: "round"
    },
    d: "M 3,-3 0,0 3,3",
    transform: "rotate(180,0.125,0)",
    sodipodiNodetypes: "ccc",
    id: "path2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    stroke: "#42C0EF",
    strokeWidth: 3,
    id: "circle7765"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g9080",
    transform: "translate(18.5,24.424999)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9124508,
    y: 2,
    width: 52.175098,
    height: 40.150002,
    rx: 4.36413,
    stroke: "#42c0ef",
    strokeWidth: 2.61848,
    id: "rect7427"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g7745",
    transform: "translate(-3.620727,-0.991182)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#660080",
      stroke: "#42c0ef",
      strokeWidth: 1.538,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      markerStart: "url(#ArrowWideRounded)",
      markerEnd: "url(#marker7)",
      paintOrder: "fill markers stroke"
    },
    d: "M 9.6277195,34.606225 46.752941,9.8032685",
    id: "path6",
    sodipodiNodetypes: "cc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonal);
export default __webpack_public_path__ + "static/media/diagonal.e4c4f2acdfee8a1b13790c5ff8d80f63.svg";
export { ForwardRef as ReactComponent };